/**
 * Encoding a string to base64 in a browser.
 */
export function encode(input: string): string {

  return btoa(input);

}
